import script from "./registerForm.vue?vue&type=script&setup=true&lang=js"
export * from "./registerForm.vue?vue&type=script&setup=true&lang=js"

import "./registerForm.vue?vue&type=style&index=0&id=9cf436ba&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9cf436ba"]])

export default __exports__